module.exports = __webpack_public_path__ + "static/media/19.dee3967b.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/19.mp3
// module id = 495
// module chunks = 0